export default {
  title: {
    en: '{selectedProductsCount, plural, one {# selected fragrance} other {# selected fragrances}}',
  },
  subTitle: {
    en: 'You can change your order later',
  },
  arrives: {
    en: 'Arrives in <b>{month} {year}</b>',
  },
  buttonTitle: {
    en: 'Continue',
  },
}
